import React from 'react';
import './RechargePowerHeaderContent.css';
import { formatKw, formatPercent } from '../../utils/format';
import vectorLight from '../../assets/VectorLight.svg';
import infoChargeCar from '../../assets/infoChargeCar2.svg';
import vectorCurveCar from '../../assets/VectorCurveCar.svg';
import elipseCharger from '../../assets/ElipseCharger.svg';
import powerSignal from '../../assets/powerSignal.svg';
import powerSignalMin from '../../assets/powerSignalMin.svg';
import powerSignalMid from '../../assets/powerSignalMid.svg';
import powerSignalMax from '../../assets/powerSignalMax.svg';
import alertIcon from '../../assets/alert-icon.png';
import { ConnectorStatus } from '../../constants/ConnectorStatus';

interface Props {
  connectorStatus: any;
  meterKWH?: any;
  chargeRateKW?: any;
  soC?: any;
  isStopTransaction?: any;
}

const RechargePowerHeaderContent: React.FC<Props> = ({
  isStopTransaction = false,
  connectorStatus,
  meterKWH,
  chargeRateKW,
  soC,
}) => {
  const powerMinValue: number = 33.33;
  const powerMidValue: number = 66.66;

  const handlePowerSignal = (
    powerValue: number,
    cmMaxPower: number,
    isConnected: boolean = true
  ) => {
    const percentual = (powerValue / cmMaxPower) * 100;

    if (!isConnected) return alertIcon;
    else if (
      percentual < 5 ||
      !connectorStatus?.status
        ?.toUpperCase()
        .includes(ConnectorStatus.CHARGING.toUpperCase())
    )
      return powerSignal;
    else if (percentual < powerMinValue) return powerSignalMin;
    else if (percentual < powerMidValue) return powerSignalMid;
    else return powerSignalMax;
  };

  return (
    <div className='recharge-power-content-container'>
      <div className='recharge-power-content'>
        <div className='recharge-power-circle-main-container'>
          <div className='recharge-power-circle-container'>
            <img alt='vector-light-icon' src={vectorLight} />
            <p>{formatKw(Number(meterKWH))}</p>
            kWh
          </div>
        </div>
      </div>
      <div className='info-charger-car-container'>
        {chargeRateKW !== null && !isStopTransaction && (
          <div className='power-signal-container'>
            {connectorStatus?.chargeRateKW > 0 && (
              <p className='powerValueContainer'>
                <span className='powerValue'>
                  {new Intl.NumberFormat('pt', {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  }).format(connectorStatus?.chargeRateKW)}{' '}
                </span>
                <span>kW</span>
              </p>
            )}
            <p>{connectorStatus?.isConnected ? null : 'Aguardando...'}</p>
          </div>
        )}
        <img
          className='info-charger-car-icon'
          alt='info-charger-car-icon'
          src={infoChargeCar}
        />
        <img
          className='info-charger-car-charger-icon'
          alt='info-charger-car-charger-icon'
          src={vectorCurveCar}
        />
        <img
          className='info-charger-car-elipse-icon'
          alt='info-charger-car-elipse-icon'
          src={elipseCharger}
        />
        {connectorStatus?.cpCode && connectorStatus?.connectorId && (
          <p className='info-charger-car-cp-id'>{`${connectorStatus?.cpCode}-${connectorStatus?.connectorId}`}</p>
        )}
        {connectorStatus?.soC !== undefined &&
          connectorStatus.cmcType === 'DC' &&
          !isStopTransaction && (
            <p className='info-charger-car-batery-info'>
              {' '}
              {`Bateria ${formatPercent(
                connectorStatus?.soC ? connectorStatus?.soC : 0
              )}`}{' '}
            </p>
          )}
      </div>
    </div>
  );
};

export default RechargePowerHeaderContent;
